import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'af-warning-panel',
    standalone: false,
    templateUrl: './warning-panel.component.html',
})
export class WarningPanelComponent {
    @Input() buttonLabel: string;
    @Input() warningText: string;
    @Input() accentText: string;
    @Output() clickListener = new EventEmitter<void>();
}
